module.exports = __webpack_public_path__ + "static/img/info-2.1e07b0e9.png";